export const eventBus = {
    on(event, callback) {
        function _callback(e) {
            callback(e.detail);
        }
        //document.addEventListener(event, (e) => callback(e.detail));
        // document.addEventListener(event, callback);
        document.addEventListener(event, _callback);

        return _callback;
    },
    dispatch(event, data) {
        document.dispatchEvent(new CustomEvent(event, { detail: data }));
    },
    remove(event, callback) {
        document.removeEventListener(event, callback);
    },
};